// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YoutubeStylePlayer_videoContainer__1eOFd {
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  background-color: #000;
  aspect-ratio: 16 / 9;
}

.YoutubeStylePlayer_video__cfILd {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.YoutubeStylePlayer_videoCover__OzS1M {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
}

.YoutubeStylePlayer_playButtonWrapper__9a-t- {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.YoutubeStylePlayer_playButtonWrapper__9a-t-:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

.YoutubeStylePlayer_playButton__fJ5PK {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}

.YoutubeStylePlayer_playButtonWrapper__9a-t-:hover .YoutubeStylePlayer_playButton__fJ5PK {
  transform: scale(1.1);
  background-color: var(--color-accent);
}

.YoutubeStylePlayer_playButtonIcon__\\+S8ZE {
  width: 40px;
  height: 40px;
}

.YoutubeStylePlayer_controlIcon__oScfk {
  width: 24px;
  height: 24px;
}

/* YouTube-подобные элементы управления */
.YoutubeStylePlayer_videoControls__uc3xH {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
  padding: 10px;
  box-sizing: border-box;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 3;
}

.YoutubeStylePlayer_videoContainer__1eOFd:hover .YoutubeStylePlayer_videoControls__uc3xH,
.YoutubeStylePlayer_showControls__qCzcx {
  opacity: 1;
}

.YoutubeStylePlayer_progressBar__LnbBy {
  width: 100%;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  margin-bottom: 10px;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.YoutubeStylePlayer_progressBar__LnbBy:hover {
  height: 6px;
}

.YoutubeStylePlayer_progress__Pt1ih {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: var(--color-accent);
  border-radius: 2px;
  transition: width 0.1s linear;
}

.YoutubeStylePlayer_controlsBottom__AraCP {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}

.YoutubeStylePlayer_leftControls__aAUI- {
  display: flex;
  align-items: center;
  gap: 16px; /* Равные отступы между элементами */
}

.YoutubeStylePlayer_controlButton__rGWLF {
  background: none;
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 0;
}

.YoutubeStylePlayer_volume__Flkzu {
  display: flex;
  align-items: center;
}

.YoutubeStylePlayer_volumeButton__TcEdv {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.YoutubeStylePlayer_volumeIcon__IEP4Q {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  cursor: pointer;
}

.YoutubeStylePlayer_volumeSlider__MR\\+rk {
  width: 60px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.YoutubeStylePlayer_volumeSlider__MR\\+rk:hover {
  height: 6px;
}

.YoutubeStylePlayer_volumeLevel__tk4tE {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: white;
  border-radius: 2px;
}

.YoutubeStylePlayer_time__2ZSP7 {
  color: white;
  font-size: 14px;
  font-family: Arial, sans-serif;
  min-width: 100px; /* Фиксированная ширина для стабильности */
}

.YoutubeStylePlayer_rightControls__ho5QE {
  display: flex;
  align-items: center;
}

.YoutubeStylePlayer_fullscreenButton__5w7Oj {
  background: none;
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  color: white;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Для мобильных устройств */
@media (max-width: 768px) {
  .YoutubeStylePlayer_volumeSlider__MR\\+rk {
    display: none;
  }
  
  .YoutubeStylePlayer_time__2ZSP7 {
    font-size: 12px;
    min-width: 80px;
  }
}

/* Добавьте эти стили к существующим */

.YoutubeStylePlayer_fullscreen__wv4aX {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #000;
  border-radius: 0 !important;
}

.YoutubeStylePlayer_fullscreen__wv4aX .YoutubeStylePlayer_video__cfILd {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.YoutubeStylePlayer_fullscreen__wv4aX .YoutubeStylePlayer_videoControls__uc3xH {
  padding: 15px 20px;
  bottom: 0;
}

.YoutubeStylePlayer_fullscreen__wv4aX .YoutubeStylePlayer_progressBar__LnbBy {
  height: 5px;
  margin-bottom: 15px;
}

.YoutubeStylePlayer_fullscreen__wv4aX .YoutubeStylePlayer_progressBar__LnbBy:hover {
  height: 8px;
}

.YoutubeStylePlayer_fullscreen__wv4aX .YoutubeStylePlayer_controlsBottom__AraCP {
  padding: 0 10px;
}

/* Убедитесь, что элементы управления видны в полноэкранном режиме */
.YoutubeStylePlayer_fullscreen__wv4aX:hover .YoutubeStylePlayer_videoControls__uc3xH {
  opacity: 1;
} `, "",{"version":3,"sources":["webpack://./src/components/Other/YoutubeStylePlayer/YoutubeStylePlayer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,4EAA4E;EAC5E,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,sCAAsC;;AAEtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,UAAU;AACZ","sourcesContent":[".videoContainer {\n  position: relative;\n  width: 100%;\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  background-color: #000;\n  aspect-ratio: 16 / 9;\n}\n\n.video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.videoCover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.playButtonWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s ease;\n}\n\n.playButtonWrapper:hover {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.playButton {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);\n}\n\n.playButtonWrapper:hover .playButton {\n  transform: scale(1.1);\n  background-color: var(--color-accent);\n}\n\n.playButtonIcon {\n  width: 40px;\n  height: 40px;\n}\n\n.controlIcon {\n  width: 24px;\n  height: 24px;\n}\n\n/* YouTube-подобные элементы управления */\n.videoControls {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);\n  padding: 10px;\n  box-sizing: border-box;\n  opacity: 0;\n  transition: opacity 0.3s;\n  z-index: 3;\n}\n\n.videoContainer:hover .videoControls,\n.showControls {\n  opacity: 1;\n}\n\n.progressBar {\n  width: 100%;\n  height: 4px;\n  background-color: rgba(255, 255, 255, 0.3);\n  margin-bottom: 10px;\n  border-radius: 2px;\n  cursor: pointer;\n  position: relative;\n}\n\n.progressBar:hover {\n  height: 6px;\n}\n\n.progress {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background-color: var(--color-accent);\n  border-radius: 2px;\n  transition: width 0.1s linear;\n}\n\n.controlsBottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 5px;\n}\n\n.leftControls {\n  display: flex;\n  align-items: center;\n  gap: 16px; /* Равные отступы между элементами */\n}\n\n.controlButton {\n  background: none;\n  border: none;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  padding: 0;\n}\n\n.volume {\n  display: flex;\n  align-items: center;\n}\n\n.volumeButton {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.volumeIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.volumeSlider {\n  width: 60px;\n  height: 4px;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  cursor: pointer;\n  position: relative;\n}\n\n.volumeSlider:hover {\n  height: 6px;\n}\n\n.volumeLevel {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background-color: white;\n  border-radius: 2px;\n}\n\n.time {\n  color: white;\n  font-size: 14px;\n  font-family: Arial, sans-serif;\n  min-width: 100px; /* Фиксированная ширина для стабильности */\n}\n\n.rightControls {\n  display: flex;\n  align-items: center;\n}\n\n.fullscreenButton {\n  background: none;\n  border: none;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  color: white;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Для мобильных устройств */\n@media (max-width: 768px) {\n  .volumeSlider {\n    display: none;\n  }\n  \n  .time {\n    font-size: 12px;\n    min-width: 80px;\n  }\n}\n\n/* Добавьте эти стили к существующим */\n\n.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  background: #000;\n  border-radius: 0 !important;\n}\n\n.fullscreen .video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.fullscreen .videoControls {\n  padding: 15px 20px;\n  bottom: 0;\n}\n\n.fullscreen .progressBar {\n  height: 5px;\n  margin-bottom: 15px;\n}\n\n.fullscreen .progressBar:hover {\n  height: 8px;\n}\n\n.fullscreen .controlsBottom {\n  padding: 0 10px;\n}\n\n/* Убедитесь, что элементы управления видны в полноэкранном режиме */\n.fullscreen:hover .videoControls {\n  opacity: 1;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoContainer": `YoutubeStylePlayer_videoContainer__1eOFd`,
	"video": `YoutubeStylePlayer_video__cfILd`,
	"videoCover": `YoutubeStylePlayer_videoCover__OzS1M`,
	"playButtonWrapper": `YoutubeStylePlayer_playButtonWrapper__9a-t-`,
	"playButton": `YoutubeStylePlayer_playButton__fJ5PK`,
	"playButtonIcon": `YoutubeStylePlayer_playButtonIcon__+S8ZE`,
	"controlIcon": `YoutubeStylePlayer_controlIcon__oScfk`,
	"videoControls": `YoutubeStylePlayer_videoControls__uc3xH`,
	"showControls": `YoutubeStylePlayer_showControls__qCzcx`,
	"progressBar": `YoutubeStylePlayer_progressBar__LnbBy`,
	"progress": `YoutubeStylePlayer_progress__Pt1ih`,
	"controlsBottom": `YoutubeStylePlayer_controlsBottom__AraCP`,
	"leftControls": `YoutubeStylePlayer_leftControls__aAUI-`,
	"controlButton": `YoutubeStylePlayer_controlButton__rGWLF`,
	"volume": `YoutubeStylePlayer_volume__Flkzu`,
	"volumeButton": `YoutubeStylePlayer_volumeButton__TcEdv`,
	"volumeIcon": `YoutubeStylePlayer_volumeIcon__IEP4Q`,
	"volumeSlider": `YoutubeStylePlayer_volumeSlider__MR+rk`,
	"volumeLevel": `YoutubeStylePlayer_volumeLevel__tk4tE`,
	"time": `YoutubeStylePlayer_time__2ZSP7`,
	"rightControls": `YoutubeStylePlayer_rightControls__ho5QE`,
	"fullscreenButton": `YoutubeStylePlayer_fullscreenButton__5w7Oj`,
	"fullscreen": `YoutubeStylePlayer_fullscreen__wv4aX`
};
export default ___CSS_LOADER_EXPORT___;
